import React from 'react'
import { Link } from 'react-router-dom'
import "./Hero.css"
const Hero = () => {
    return (
        <>
            <section className="hero-part">
                <div className="first">
                    <h1 className="heading">Welcome to, SAS Tech</h1>
                    <p className="desc">All your Business Queries from Development to Marketing Can be Solved here</p>
                    <a href='#contact'className="btn">Let's work together</a>
                </div>
                <img src="./images/logosastech.jpg" alt="" />
            </section>
        </>
    )
}

export default Hero